import { render, staticRenderFns } from "./custom-company-brand.vue?vue&type=template&id=ef293038&scoped=true&"
import script from "./custom-company-brand.vue?vue&type=script&lang=js&"
export * from "./custom-company-brand.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-brand.vue?vue&type=style&index=0&id=ef293038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef293038",
  null
  
)

export default component.exports